<template>
    <div class="custom-page">
        <!--    3D图纸    -->
        <div v-if="threeDLink" class="custom-wrap">
            <div class="title-box">3D图纸</div>

            <!--        3D图纸设计        -->
            <div class="room-design-3d">
                <div class="the-3d-content">
                    <img class="image-3d" v-lazy="require('@/assets/images/project-detail/0004-test.png')" alt=""/>
                    <div class="look-detail">
                        <img class="three-icon" :src="require('@/assets/images/project-detail/three-d-icon.png')" alt=""/>
                        <div @click="open3DLink" class="three-btn">点击查看</div>
                    </div>
                </div>
            </div>
        </div>
        <!--  依据  -->
        <div class="custom-wrap" v-if="objUserCustomListData[0].children.length">
            <div class="title-box">方案定制依据</div>
            <div class="custom-content">
                <!--        房屋特性        -->
                <!--                <div>-->
                <!--                    <customTitle :id="sAnchorBefore + 'roomC'" class="custom-default-title" title="房屋特性"/>-->
                <!--                    <div class="characteristics-content">-->
                <!--                        &lt;!&ndash;            循环项            &ndash;&gt;-->
                <!--                        <div class="characteristics-item" v-for="item in arrCharacteristics" :key="item.name">-->
                <!--                            <span class="title">{{ item.name }}</span>-->
                <!--                            <div>-->
                <!--                                <p v-for="va in item.value" :key="va">{{ va }}</p>-->
                <!--                            </div>-->
                <!--                        </div>-->
                <!--                        &lt;!&ndash;  特殊线  &ndash;&gt;-->
                <!--                        <div class="liner"></div>-->
                <!--                    </div>-->
                <!--                </div>-->

                <!--        用户个性化需求        -->
                <div>
                    <customTitle :id="sAnchorBefore + 'userC'" class="custom-default-title" title="用户个性化需求"/>
                    <div class="personalized-content">
                        <!--    循环项     -->
                        <customPerson v-for="(item,index) in objUserCustomListData" :sourceList="item.children" :key="index" :title="item.title"/>
                    </div>
                </div>
            </div>
        </div>

        <!--    方案    -->
        <div class="custom-wrap" v-if="objDesignParamsData.length || arrProductInfo.length || arrSystemFunctionList.length">
            <div class="title-box">VIP系统定制方案</div>
            <div class="custom-content vr-custom-content">
                <!--        设计参数        -->
                <div v-if="objDesignParamsData.length">
                    <customTitle :id="sAnchorBefore + 'designC'" class="custom-default-title" title="设计参数"/>
                    <div class="parameters-content">
                        <customCharacter :sourceList="objDesignParamsData[1]" title="冷暖系统"/>
                        <!--  特殊线  -->
                        <div class="parameters-liner"></div>
                        <customCharacter :sourceList="objDesignParamsData[3]" title="新风系统"/>
                        <!--  特殊线  -->
                        <div class="parameters-liner"></div>
                        <customCharacter :sourceList="objDesignParamsData[4]" title="水系统"/>
                        <!--  特殊线  -->
                        <div class="parameters-liner"></div>
                    </div>
                </div>

                <!--        系统配置        -->
                <div class="system-option" v-if="arrProductInfo.length">
                    <customTitle :id="sAnchorBefore + 'systemC'" class="custom-default-title" title="系统配置"/>
                    <div class="option-content">
                        <div class="option-item" @click="openProductDetail(item)" v-for="(item,index) in arrProductInfo" :key="index">
                            <div class="image-container">
                                <img v-lazy="item.img"/>
                            </div>
                            <div class="option-text">
                                <div class="clamp-text">{{ item.name }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--        系统功能        -->
                <div v-if="arrSystemFunctionList.length">
                    <customTitle :id="sAnchorBefore + 'functionC'" class="custom-default-title" title="系统功能"/>
                    <div class="function-content">
                        <customSystem v-for="(item,index) in arrSystemFunctionList" :open="item.open" :info="item" :key="index" class="system-option-func"/>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import customTitle from "./components/custom-title";
import customPerson from "./components/custom-person";
import customCharacter from "./components/custom-character";
import customSystem from "./components/custom-system";
import {mapState} from "vuex";
import {projectDetailMixin} from "@/page/project/detail/mixin";

export default {
    name: "custom",
    components: {
        customTitle,
        customPerson,
        customCharacter,
        customSystem,
    },
    mixins: [projectDetailMixin],
    data() {
        return {
            // 房屋特性数组
            arrCharacteristics: [
                {
                    name: "房屋朝向",
                    value: ["南北向"],
                },
                {
                    name: "层高",
                    value: ["3m"],
                },
                {
                    name: "房屋保温",
                    value: ["外墙保温", "+双层隔热窗"],
                },
                {
                    name: "用水点",
                    value: ["2卫1厨"],
                },
                {
                    name: "冬季平均最低气温",
                    value: ["4°c"],
                },
                {
                    name: "冬季进水温度",
                    value: ["4°c"],
                },
            ],
            // 锚点前缀
            sAnchorBefore: "S_t_k",
        };
    },
    computed: {
        ...mapState({
            // 用户个性化需求数据
            objUserCustomListData: (state) => state.projectDetailCustom.objUserCustomListData,
            // 设计参数数据
            objDesignParamsData: (state) => state.projectDetailCustom.objDesignParamsData[0],
            // 系统功能
            arrSystemFunctionList: (state) => state.projectDetailCustom.arrSystemFunctionList,
            // 产品数据
            arrProductInfo: (state) => state.projectDetailCustom.arrProductInfo,
            // 3D链接
            threeDLink: (state) => state.projectDetailCustom.threeDLink,
        }),
    },
    beforeRouteEnter(form, to, next) {
        next((vm) => {
            // 保证系统功能模块第一个打开
            const target = vm.arrSystemFunctionList[0];
            if (!target.open) {
                vm.$store.commit({type: 'projectDetailCustom/CHANGE_SYSTEM_FUNC_VISIBLE', id: target?.id})
                vm.$store.commit({type: 'projectDetailCustomBeijingOne/CHANGE_SYSTEM_FUNC_VISIBLE', id: target?.id})
            }
        });
    },
    methods: {
        /**
         * 打开3D链接
         */
        open3DLink() {
            window.location.href = this.threeDLink + '&noinfo=true';
        },
        /**
         * 打开产品详情
         * @param item
         */
        openProductDetail(item) {
            this.$router.push(
                // item.id === 1045                    ?
                {path: "/shopp/details", query: {id: item.id}}
                // : {path: "/project/detail/custom/image-view", query: {id: item.id}}
            );
        },


    },
};
</script>

<style lang="scss" scoped>
@import "custom";
</style>
